import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.css';

import { Suspense } from 'react';

import { BrowserRouter } from 'react-router-dom'

import logo from './assets/images/AHHM-Preloader.gif'

import store from './store';
import { Provider } from 'react-redux';
import i18n from 'i18next';
import audio from './assets/images/mixkit-people-in-airport-ambience-1567.wav'

import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';



i18n.use(initReactI18next).use(LanguageDetector).use(HttpApi).init({
  supportedLngs: ['en', 'tk', 'ru'],
  lng: 'tk',
  fallbackLng: "tk",
  detection: {
    order: ['cookie', 'htmlTag', 'localStorage', 'path', 'subdomain', 'sessionStorage'],
    caches: ['cookie'],
  },
  // ns: ["tk"],
  // defaultNS: "tk",
  backend: {
    loadPath: '/locales/{{lng}}/translation.json',
  },
  react: { useSuspense: false },
  debug: false,
});



const Loading = () => {
  const [isLoading, setIsLoading] = useState(true)
  // let crowd = document.getElementById('crowd');
    // crowd.play()
  setTimeout(() =>{
    setIsLoading(false)
    // let crowd = document.getElementById('crowd');
    // crowd.pause()
  },3000)
  
  return (
  
    isLoading &&
    <div className='loading v_100'>
      <div>
        <img src={logo} alt='' />
      </div>
      {/* <audio preload='auto' src={audio} id='crowd'/> */}
    </div> 
  
  )
}

const root = ReactDOM.createRoot(document.getElementById('__react'));

root.render(
  <Suspense fallback={<Loading />}>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter >
    </Provider>
  </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
